import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import redBallLogo from '../../media/red-ball.png'

export default function ANCLSeriesDetails() {
  const { sid } = useParams()
  const [seriesData, setSeriesData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://ccapi.cricclubs.com/CCAPI/match/getMatches?X-Auth-Token=&clubId=16685&seriesId=${sid}&teamId=123`
        )

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        setSeriesData(data)
      } catch (err) {
        setError(err.message)
        setSeriesData(null)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [sid]) // Added sid to dependency array

  return (
    <div className='container my-5'>
      <div className='top-heading m-auto'>
        <img src={redBallLogo} alt='Cricket ball' />
        <span>SERIES</span>
      </div>

      <h1 className='text-center mb-4'>
        <strong>Series Maverickscc Played</strong>
      </h1>

      {loading && (
        <div className='d-flex justify-content-center'>
          <div className='spinner-border' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
        </div>
      )}

      {error && (
        <div className='alert alert-danger'>
          There was a problem fetching the series data: {error}
        </div>
      )}

      {seriesData && (
        <div className='row'>
          {Object.values(seriesData).map((seriesGroup, groupIndex) => (
            <React.Fragment key={`group-${groupIndex}`}>
              {Object.values(seriesGroup).map((match, matchIndex) => (
                <div className='col-lg-6 my-3' key={`match-${groupIndex}-${matchIndex}`}>
                  <div className='series-box'>
                    <h3>{match.matchId}</h3>
                    {/* Add more match details here */}
                  </div>
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  )
}
